@if (!disableHeader) {
  <ion-header [translucent]="true">
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-menu-button (click)="closePopup()"></ion-menu-button>
      </ion-buttons>
      <ion-title >
        <div class="titleBar">
          {{ title  | translate }}
          @if (NotificationService.showNotificationBell) {
            <ion-buttons class="notificationbutton" (click)="this.NotificationBellService.openNotificationBell(this.AllNotifications)">
              <div class="bellimgContainer">
                <!--<fa-icon icon="bell" id="bellsize"></fa-icon>-->
                <fa-icon [icon]="bellIcon" id="bellsize"></fa-icon>
                <!--<fa-icon icon="bellIcon" id="bellsize"></fa-icon>-->
                <!--<app-app-icon name="bell" id="bellsize"></app-app-icon>-->
                <!--<img id="bellsize" src="../../../../assets/icon/notification/bell.png" alt="">-->
                @if (this.valideNotification > 0) {
                  <div class="notificationCircle">
                    <p>{{this.valideNotification}}</p>
                  </div>
                }
              </div>
            </ion-buttons>
          }
        </div>
      </ion-title>
    </ion-toolbar>
  </ion-header>
}

<ion-content class="content-theme-one">

  <ion-segment class="segmentSetup" [(ngModel)]="currentSegment" [ngClass]="{'ispopup': this.isPopup}">
    <ion-segment-button  class="button" value="contact">
      <ion-label [ngClass]="{'PopupLabel': this.isPopup}">{{ 'Support.Contact' | translate }}</ion-label>
    </ion-segment-button>
    <ion-segment-button class="button" value="faq">
      <ion-label [ngClass]="{'PopupLabel': this.isPopup}">{{ 'Support.Faq' | translate }}</ion-label>
    </ion-segment-button>
    <!--<ion-segment-button  class="button" value="case">
    <ion-label> {{ 'Support.Case' | translate}}(1)</ion-label>
  </ion-segment-button>-->
  <ion-segment-button  class="button terms" value="terms">
    <ion-label [ngClass]="{'PopupLabel': this.isPopup}">{{ 'Support.Terms' | translate }}</ion-label>
  </ion-segment-button>
</ion-segment>


<ion-card [ngClass]="{'disable-box-shadow': !this.setting.UIaddBoxShadow, 'disable-background-color': !this.setting.UIshowBackground}">
  <div style="padding: 15px; padding-top: 0; margin-bottom: 20px;">
    @switch (currentSegment) {
      @case ('contact') {
        <ion-list class="disable-background-color">
          <support-contact-page></support-contact-page>
        </ion-list>
      }
      @case ('faq') {
        <ion-list class="disable-background-color">
          <support-faq-page></support-faq-page>
        </ion-list>
      }
      @case ('case') {
        <ion-list class="disable-background-color" style="padding-top: 0px; padding-bottom: 0px;">
          <support-cases></support-cases>
        </ion-list>
      }
      @case ('terms') {
        <ion-list class="disable-background-color">
          <support-terms-page></support-terms-page>
        </ion-list>
      }
    }
  </div>
</ion-card>





<!--<ion-content [fullscreen]="false">
<support-contact-page></support-contact-page>
-->


@if ((mobile && isPopup && !setting.navigationSetting) && setting.configuration.uIoptions) {
  <app-undocked-navigation-bar style="z-index: 10;" [disabledOption]="'Nav.Support'"></app-undocked-navigation-bar>
}
</ion-content>

<!--<ion-tabs>
<ion-tab-bar slot="bottom">
  <ion-tab-button tab="contact">
    <ion-icon name="calendar"></ion-icon>
    <ion-label>Schedule</ion-label>
    <ion-badge>6</ion-badge>
  </ion-tab-button>

  <ion-tab-button tab="speakers">
    <ion-icon name="person-circle"></ion-icon>
    <ion-label>Speakers</ion-label>
  </ion-tab-button>

  <ion-tab-button tab="map">
    <ion-icon name="map"></ion-icon>
    <ion-label>Map</ion-label>
  </ion-tab-button>

  <ion-tab-button tab="about">
    <ion-icon name="information-circle"></ion-icon>
    <ion-label>About</ion-label>
  </ion-tab-button>
</ion-tab-bar>
</ion-tabs>-->